import { RouteObject } from 'react-router-dom';
import React from 'react';
import { HOME_ROUTE } from './route.definitions';
import { HomePage } from './page';

export const homeRoutes = (el: JSX.Element = <HomePage />): RouteObject => ({
  path: HOME_ROUTE.ABSOLUTE_PATH,
  element: el,
});
